import { useState } from "react";
import { rpc, fmtDateTime, isUuid } from "@/lib/booking";
import { Card, Field, Area, Select, SaveBtn, Ok, Err, Toggle, useAction } from "./adminUI";

const EMPTY = { tour_id: "", slot_id: "", date: "", adults: 1, children_paid: 0, children_free: 0, name: "", phone: "", email: "", notes: "" };

export function NewBookingForm({ tours, slots, onCreated }) {
    const [f, setF] = useState(EMPTY);
    const [confirmNow, setConfirmNow] = useState(true);
    const { run, busy, msg, err } = useAction();
    const set = (k) => (v) => setF((o) => ({ ...o, [k]: v }));
    const tour = tours.find((t) => t.id === f.tour_id);
    const tourSlots = slots.filter((s) => s.tour_id === f.tour_id);

    const submit = () => run(async () => {
        const p = { ...f, slot_id: f.slot_id || null, date: f.slot_id ? null : f.date || null,
            adults: Number(f.adults), children_paid: Number(f.children_paid), children_free: Number(f.children_free) };
        const res = await rpc("create_booking", { p });
        if (confirmNow && p.slot_id) await rpc("admin_update_booking_status", { p_id: res.id, p_status: "confirmed", p_note: "Criada e confirmada pela administração" });
        setF(EMPTY);
        onCreated();
    }, "Reserva criada");

    return (
        <Card className="space-y-4" >
            <div className="grid gap-4 sm:grid-cols-2" data-testid="new-booking-form">
                <Select label="Experiência" value={f.tour_id} onChange={(v) => setF({ ...f, tour_id: v, slot_id: "" })} testid="new-booking-tour"
                    options={[["", "Selecione"], ...tours.filter((t) => isUuid(t.id)).map((t) => [t.id, t.title])]} />
                <Select label="Horário cadastrado" value={f.slot_id} onChange={set("slot_id")} testid="new-booking-slot"
                    options={[["", tour?.booking_type === "scheduled" ? "Selecione" : "Sem horário (data a combinar)"], ...tourSlots.map((s) => [s.id, fmtDateTime(s.starts_at)])]} />
                {!f.slot_id && <Field label="Data desejada (sem horário)" type="date" value={f.date} onChange={set("date")} testid="new-booking-date" />}
                <Field label="Adultos" type="number" value={f.adults} onChange={set("adults")} testid="new-booking-adults" />
                <Field label="Crianças (pagantes)" type="number" value={f.children_paid} onChange={set("children_paid")} />
                <Field label="Crianças (gratuidade)" type="number" value={f.children_free} onChange={set("children_free")} />
                <Field label="Nome do responsável" value={f.name} onChange={set("name")} testid="new-booking-name" />
                <Field label="WhatsApp com DDD" value={f.phone} onChange={set("phone")} testid="new-booking-phone" />
                <Field label="E-mail" type="email" value={f.email} onChange={set("email")} testid="new-booking-email" />
            </div>
            <Area label="Observações" value={f.notes} onChange={set("notes")} />
            <div className="flex flex-wrap items-center justify-between gap-3">
                <Toggle checked={confirmNow} onChange={setConfirmNow} label="Confirmar vaga imediatamente" testid="new-booking-confirm" />
                <div className="flex items-center gap-3"><Ok msg={msg} /><Err msg={err} />
                    <SaveBtn onClick={submit} saving={busy} testid="new-booking-submit">Criar reserva</SaveBtn></div>
            </div>
        </Card>
    );
}
